import { Navigate, Outlet } from "react-router";

export default function ProtectedRoutes({ auth }) {
  return auth ? <Outlet /> : <Navigate to="/notauthorized" />;
}
